import React, { useCallback, useEffect } from 'react';
import { useOutSideClick } from '../../../hooks/useOutSideClick';
import { handleBetAmountLimits } from '../../../core/helpers/handleBetAmountLimits';
import { userInfoStore } from '../../../store/userInfoStore';

function NumpadWrapper({ children, isNumpadActive, setIsNumpadActive }) {
  const [ref, isOutSideClick] = useOutSideClick();
  const { betAmount, setBetAmount, limits, precision } = userInfoStore;
  const handleBlurBetAmount = useCallback(
    () => handleBetAmountLimits(limits.maxBet, limits.minBet, betAmount, setBetAmount, precision),
    [betAmount, limits, setBetAmount, precision]
  );

  useEffect(() => {
    if (isOutSideClick && isNumpadActive) {
      setIsNumpadActive(false);
      handleBlurBetAmount();
    }
  }, [isOutSideClick, setIsNumpadActive, handleBlurBetAmount]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const preventScroll = (e) => {
      e.preventDefault();
    };
    const currentRef = ref.current;

    if (isNumpadActive && currentRef) {
      currentRef.addEventListener('touchmove', preventScroll, { passive: false });
      currentRef.addEventListener('wheel', preventScroll);
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('touchmove', preventScroll);
        currentRef.removeEventListener('wheel', preventScroll);
      }
    };
  }, [isNumpadActive, ref]);

  return (
    <div className={`numpad-wrapper ${isNumpadActive ? 'active' : ''}`} ref={ref}>
      <div className='numpad-wrapper-inner'>{children}</div>
    </div>
  );
}

export default NumpadWrapper;
